module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-cc-20d061aa.svg";